import React from "react";
import LandingPage from "./LandingPage";
import { freeVendingContent } from "../data/landingContent";

export default function FreeVending() {
  return <LandingPage content={freeVendingContent} />;
}
